// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  /* Placeholder Styles */
  .is-empty::before {
    color: rgba(0, 0, 0, 0.4); /* text-black/40 */
    float: left; /* float-left */
    height: 0; /* h-0 */
    pointer-events: none; /* pointer-events-none */
    width: 100%; /* w-full */
  }

  &.ProseMirror-focused {
    /* Slashmenu Placeholder */
    > p.has-focus.is-empty::before {
      content: "Type  /  to browse options";
    }

    > [data-type="columns"]
      > [data-type="column"]
      > p.is-empty.has-focus::before {
      content: "Type  /  to browse options";
    }
  }

  /* Default Placeholder */
  & > .is-editor-empty::before {
    content: "Click here to start writing …";
  }

  /* Blockquote Placeholder */
  blockquote .is-empty:not(.is-editor-empty):first-child:last-child::before {
    content: "Enter a quote";
  }

  blockquote + figcaption.is-empty:not(.is-editor-empty)::before {
    content: "Author";
  }

  [data-placeholder][data-suggestion]::before,
  [data-placeholder][data-suggestion] *::before {
    content: none !important;
  }

  /* Details Placeholder */
  [data-type="details"].is-editor-empty::before {
    content: none !important;
  }

  [data-type="details"] summary.is-empty::before {
    content: "Enter a summary";
  }

  [data-type="detailsContent"] .is-empty::before {
    content: "Enter details";
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/placeholder.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB;IACE,yBAAyB,EAAE,kBAAkB;IAC7C,WAAW,EAAE,eAAe;IAC5B,SAAS,EAAE,QAAQ;IACnB,oBAAoB,EAAE,wBAAwB;IAC9C,WAAW,EAAE,WAAW;EAC1B;;EAEA;IACE,0BAA0B;IAC1B;MACE,qCAAqC;IACvC;;IAEA;;;MAGE,qCAAqC;IACvC;EACF;;EAEA,wBAAwB;EACxB;IACE,wCAAwC;EAC1C;;EAEA,2BAA2B;EAC3B;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA,wBAAwB;EACxB;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".ProseMirror {\n  /* Placeholder Styles */\n  .is-empty::before {\n    color: rgba(0, 0, 0, 0.4); /* text-black/40 */\n    float: left; /* float-left */\n    height: 0; /* h-0 */\n    pointer-events: none; /* pointer-events-none */\n    width: 100%; /* w-full */\n  }\n\n  &.ProseMirror-focused {\n    /* Slashmenu Placeholder */\n    > p.has-focus.is-empty::before {\n      content: \"Type  /  to browse options\";\n    }\n\n    > [data-type=\"columns\"]\n      > [data-type=\"column\"]\n      > p.is-empty.has-focus::before {\n      content: \"Type  /  to browse options\";\n    }\n  }\n\n  /* Default Placeholder */\n  & > .is-editor-empty::before {\n    content: \"Click here to start writing …\";\n  }\n\n  /* Blockquote Placeholder */\n  blockquote .is-empty:not(.is-editor-empty):first-child:last-child::before {\n    content: \"Enter a quote\";\n  }\n\n  blockquote + figcaption.is-empty:not(.is-editor-empty)::before {\n    content: \"Author\";\n  }\n\n  [data-placeholder][data-suggestion]::before,\n  [data-placeholder][data-suggestion] *::before {\n    content: none !important;\n  }\n\n  /* Details Placeholder */\n  [data-type=\"details\"].is-editor-empty::before {\n    content: none !important;\n  }\n\n  [data-type=\"details\"] summary.is-empty::before {\n    content: \"Enter a summary\";\n  }\n\n  [data-type=\"detailsContent\"] .is-empty::before {\n    content: \"Enter details\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
